<template>
  <div
    class="regfest-service-slider"
  >
    <swiper
      ref="mySwiper"
      class="regfest-service-slider__wrapper"
      :options="swiperOption"
    >
      <swiper-slide
        v-for="(slide, index) in data"
        :key="index"
        class="regfest-service-slider__slide"
        :class="{'regfest-service-slider__slide--holiday': slide.dayOff, 'regfest-service-slider__slide--active': showSelected(index)}"
      >
        {{ slide.dayNumber }} {{ slide.dayName }}
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';


export default {
  name: 'Slider',
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  data() {
    return {
      selectedSlideIndex: 0,
      swiperOption: {
        slidesPerView: 8,
        slideToClickedSlide: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 3,
          },
          640: {
            slidesPerView: 2,
          },
          320: {
            slidesPerView: 1,
          }
        },
        on: {
          click: this.onChange,
        }
      },
    };
  },
  methods: {
    onChange() {
      if(typeof this.swiper.clickedIndex !== 'undefined'){
        this.selectedSlideIndex = this.swiper.clickedIndex;
        this.$emit('slide-click', this.data[this.selectedSlideIndex])
      }
    },
    setActiveSlide(index) {
      this.selectedSlideIndex = index;
    },
    showSelected(index = 0) {
      return this.selectedSlideIndex === index;
    },
    calculateActiveSlide() {
      const {date} = this.$route.query;
      let selectedIndex = 0;
      let activeIndexByDate = undefined;
      this.data.forEach((item, index) =>  {
        if(date ===  item.date) {
          activeIndexByDate = index;
        }
      });
      if (typeof activeIndexByDate !== 'undefined') {
        this.setActiveSlide(activeIndexByDate);
        this.swiper.slideTo(activeIndexByDate);
      } else {
        this.setActiveSlide(selectedIndex);
        this.swiper.slideTo(selectedIndex);
      }
    }
  },
  mounted() {
    this.calculateActiveSlide();
  },
  watch: {
    data: {
      handler: function () {
        this.calculateActiveSlide();
      }
    },
    '$route.query.date' : {
      handler: function () {
        this.calculateActiveSlide();
      }
    }
  }
};
</script>

<style lang="scss">
.regfest-service-slider {
  width: 100%;
  max-width: 810px;
  .swiper-button-next {
    right: 0;
    opacity: 1;
    background-size: 15px 15px;
    background-color: white;
  }
  .swiper-button-prev {
    left: 0;
    opacity: 1;
    background-size: 15px 15px;
    background-color: white;
  }

  &__wrapper {
    padding: 10px;
  }
  &__slide {
    border-bottom: 1px solid #BDBDBD;
    cursor: pointer;
    text-align: center;
    &:hover,
    &--active {
      border-bottom: 1px solid #2F80ED;
    }
    &--holiday {
      color: red;
    }
  }
}
</style>
